<style lang="scss">
  .modal-contents {
    background: white;
    border-radius: 0.5rem;
    animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    max-width: 70rem;
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  @keyframes zoom {
    from {
      transform: scale(0.95);
    }
    to {
      transform: scale(1);
    }
  }
</style>

<script>
  export let showModal;
  export let maxHeight;

  $: document.body.classList.toggle("no-scroll", showModal);
</script>

{#if showModal}
  <div class="modal-overlay">
    <div
      class="modal-contents"
      style={maxHeight ? `max-height: ${maxHeight}; height: 95%;` : ""}
    >
      <slot />
    </div>
  </div>
{/if}
